import MDBox from "components/MDBox";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import complete from "assets/images/ok-g1e439af7f_640.png";
import DialogTitle from "@mui/material/DialogTitle";
import React, { useState} from "react";
import MDBackdrop from "components/MDBackdrop";
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import { useMaterialUIController } from "context";
import theme from "assets/theme";

function Completion(props) {
    const [isBackdrop] = useState(false);
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;
    const { onClose } = props;

    const handleClose = () => {
        onClose(false);
        window.location.reload();
    };

    return (
        <>
            <MDBackdrop isBackdrop={isBackdrop} />
            <Dialog open={props.isDialog} onClose={handleClose} fullWidth maxWidth="md">
                <DialogTitle style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" ,display : "flex", alignItems : "center", justifyContent : "space-between"} : {theme,display : "flex", alignItems : "center", justifyContent : "space-between"}}>
                
                    Location Created successfully!!
                    <IconButton aria-label="delete" style={darkMode ? {color: "#ffffff"} : theme} onClick={handleClose}>
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
                <DialogContent style={darkMode ? { backgroundColor: "#202940", color: "#ffffff" } : theme}>
                    <MDBox pt={0} pb={0} style={{display : "flex" , justifyContent : "center", height : "50vh"}}>
                        <img src={complete} alt="Location Created successfully!!" />
                        </MDBox>
                </DialogContent>
            </Dialog>
        </>
    );
}

export default Completion;